// Import 3rd-party dependencies
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, share } from 'rxjs/operators';
import { of, Observable } from 'rxjs';

// Import project-specific dependencies
import { ApiService } from '@app/services/api.service';
import { environment } from '@app/environments/environment';

export interface IPermissionDetails {  
  email: string,
  coreId: string,
  name: string,
  directReports: boolean,
  region: boolean,
  department: boolean,
  regionName: string,
  departmentName: string,
  allDXC: boolean,
  isTopBanner: boolean,
  addedBy: string, 
}

@Injectable({
  providedIn: 'root'
})
    
export class AddPermissionService extends ApiService {
  private ADMIN_API_URL = environment.DEPS.ADMIN_API.URL;
  private permissions: IPermissionDetails[] = [];
  
  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  savePermission(permissions: IPermissionDetails[]): void {
    const permissionsArray: {[key: string]: string | boolean } = { };
    permissions[0]['directReports'] ? permissionsArray['directReports'] = true : permissionsArray['directReports'] = false;
    permissions[0]['region'] ? permissionsArray['region'] = permissions[0]['regionName'] : permissionsArray['region'] = '';
    permissions[0]['department'] ? permissionsArray['department'] = permissions[0]['departmentName'] : permissionsArray['department'] = ''
    permissions[0]['allDXC'] ? permissionsArray['allDXC'] = true : permissionsArray['allDXC'] = false;

    permissions.forEach(permissionObj => {
      if(permissionObj.email) 
      {
        const userPermission = [{          
          email: permissionObj.email,
          coreId: permissionObj.coreId,
          name: permissionObj.name, 
          permissionLevels: permissionsArray,
          isTopBanner: permissionObj.isTopBanner,
          addedBy: permissionObj.addedBy 
        }]
        return this.put<IPermissionDetails>(`${this.ADMIN_API_URL}/me/announcementpermission`, userPermission[0]).subscribe(data => {
          catchError(() => of(null))
        });
      }
    });
  }

  getPermissions(): Observable<IPermissionDetails> {
    return this.get<IPermissionDetails>(`${this.ADMIN_API_URL}/me/announcementpermission`)
  }

  searchPeople(searchQuery: string): Observable<any> {
    const url = `${this.ADMIN_API_URL}/me/announcementpermission`;
    return this.get<any>(url).pipe(
      map((res) => res.filter(user => user.email == searchQuery))
    )
  }

  removePermission(email: string, coreId: string): void {    
    this.delete(`${this.ADMIN_API_URL}/me/announcementpermission/delete?id=${email.trim()}`).subscribe(data => {
      this.delete(`${this.ADMIN_API_URL}/me/announcements/delete?id=${coreId.trim()}`).subscribe(data => {
        return data;
      });  
    });  
  }
}


